module.exports = __webpack_public_path__ + "img/Picture7.f0d0beed.png";